import { TabTranslations } from './types';

export const deTranslations: TabTranslations = {
    tabs: {
        diseases: "Krankheiten",
        scoring: "Bewertung",
        config: "Konfiguration"
    }
};